export class SearchResult<T> {
    totalResults: number;
    pageSize: number;
    results: Array<T>;
    continuationToken: string;
}
